import { GraphQLQuery } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button, Container, Loader } from "semantic-ui-react";
import { AccountDropdown } from "../accounts";
import { CheckoutMutation } from "../API";
import { checkout } from "../graphql/mutations";
import { NavBar } from "./NavBar";
import { useProducts } from "./Products";

export const Checkout: FC = () => {
    const {isLoading, data} = useProducts();
    const { accountId, productId } = useParams<{ productId: string, accountId: string }>();
    const [checkoutState, setCheckoutState] = useState<undefined | string>(undefined);
    const [product, setProduct] = useState<any>(undefined);

    useEffect( () => {
        if (!isLoading && productId) {
            setProduct(data.find((p: any) => p.id === productId));
        }
    }, [isLoading])

    useEffect( () => {
        if (isLoading || !product) {
            document.title = `Checkout...`
        } else if (productId && !accountId) {
            document.title = `Checkout for ${product.name}`
        } else {
            document.title = `Checkout for ${accountId} for ${product.name}`
        }
    }, [accountId, productId, product]);


    if (isLoading) {
        return (
            <Container>
                <NavBar />
                <h1>Checkout</h1>
                <div>Loading Products...</div>
                <Loader active inline='centered' />
            </Container>
        )
    }

    const gotoCheckout = async () => {
        try {
            setCheckoutState(`Initalizing checkout...`);
            const checkoutResponse = await API.graphql<GraphQLQuery<CheckoutMutation>>({
                query: checkout,
                variables: { accountId, productId }
            });
            const redirectUrl = checkoutResponse.data?.checkout?.body;
            if (!redirectUrl || checkoutResponse.data?.checkout?.statusCode !== 200) {
                return setCheckoutState(`Error initializing checkout, please try again.`);
            }
            console.log(checkoutResponse, redirectUrl);
            setCheckoutState(`Redirecting to checkout page...`);
            window.location.href = JSON.parse(redirectUrl);
            // window.location.replace(redirectUrl);
        } catch (error) {
            setCheckoutState(`Error initializaing checkout, please try agaiin: ${JSON.stringify(error)}`);
        }
    }

    const buttonEnabled = accountId && productId
        && ((!checkoutState) // undefined
            || (checkoutState?.indexOf('Error') || -1) >= 0); // has 'Error', to try again

    return (
        <Container>
            <NavBar/>
            <AccountDropdown navigatePath={`/checkout/pay/ACCOUNT_ID/${productId}`}/>
            <h1>Checkout - {product?.name}</h1>
            <p>Price: {product?.price}</p>
            <Button disabled={!buttonEnabled} primary onClick={() => gotoCheckout()}>Checkout</Button>
            { checkoutState && <div>{checkoutState}</div> }
        </Container>
    )
}